"use strict";

exports.__esModule = true;
var _APIQueryController = require("./APIQueryController");
Object.keys(_APIQueryController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _APIQueryController[key]) return;
  exports[key] = _APIQueryController[key];
});